// import React from "react";
// import {
//   imageCodes,
//   textCodes,
//   titleCodes,
//   videoCodes,
// } from "../../template_codes/asteria/home_page_codes";
// import logo from "../../assets/images/asteria/asteria_logo.png";

// function Home() {
//   return (
//     <React.Fragment>
//       <div className="font-quicksand">
//         {/*            homepage slider section              */}
//         <div className="carousel w-full">
//           <div id="slide1" className="carousel-item relative w-full">
//             <img
//               src={imageCodes.homeSlider1.image}
//               className="py-1 w-full h-48 md:h-full lg:h-full xl:h-full"
//             />
//             <a
//               href="https://theasteria.shop/shop"
//               className="uppercase shadow-2xl top-[70%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 cursor-pointer text-[#d9b4b2] absolute font-bold bg-white text-xs px-5 py-2 lg:px-10 lg:py-3  hover:scale-105 transition duration-300 rounded-full "
//             >
//               Shop Now
//             </a>
//             <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
//               <a href="#slide2" className="btn btn-circle w-4 h-4">
//                 ❮
//               </a>
//               <a href="#slide2" className="btn btn-circle w-4 h-4">
//                 ❯
//               </a>
//             </div>
//           </div>
//           <div id="slide2" className="carousel-item relative w-full">
//             <img
//               src={imageCodes.homeSlider2.image}
//               className="py-1 w-full h-48 md:h-full lg:h-full xl:h-full"
//             />
//             <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
//               <a href="#slide1" className="btn btn-circle w-4 h-4">
//                 ❮
//               </a>
//               <a href="#slide1" className="btn btn-circle w-4 h-4">
//                 ❯
//               </a>
//             </div>
//           </div>
//         </div>
//         {/*            end of
//                 homepage slider section              */}

//         {/*                      Categories Section                        */}
//         <div className="container px-10 md:px-14 lg:px-20 xl:px-44 pt-20 pb-10">
//           <h1 className="text-2xl md:text-2xl lg:text-3xl xl:text-3xl text-center pb-10 font-semibold">
//             {titleCodes.category.title}
//           </h1>
//           <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 xl:grid-cols-6 place-items-center gap-2">
//             <div className="pb-10 place-items-center">
//               <a href="https://theasteria.shop/">
//                 <img
//                   src={imageCodes.collection1.image}
//                   className="rounded-full w-28 h-28 place-items-center"
//                 ></img>
//                 <p className="text-md text-base md:pt-4 text-center">
//                   Blazer & Date Set
//                 </p>
//               </a>
//             </div>
//             <div className="pb-10 place-items-center">
//               <a href="https://theasteria.shop/">
//                 <a href="https://theasteria.shop/">
//                   <img
//                     src={imageCodes.collection2.image}
//                     className="rounded-full w-28 h-28 place-items-center"
//                   ></img>
//                   <p className="text-md text-base md:pt-4 text-center">
//                     Amber Brown Set
//                   </p>
//                 </a>
//               </a>
//             </div>
//             <div className="pb-10 place-items-center">
//               <a href="https://theasteria.shop/">
//                 <a href="https://theasteria.shop/">
//                   <img
//                     src={imageCodes.collection1.image}
//                     className="rounded-full w-28 h-28 place-items-center"
//                   ></img>
//                   <p className="text-md text-base md:pt-4 text-center">
//                     Ready-Set-Go!
//                   </p>
//                 </a>
//               </a>
//             </div>
//             <div className="pb-10 place-items-center">
//               <a href="https://theasteria.shop/">
//                 <a href="https://theasteria.shop/">
//                   <img
//                     src={imageCodes.collection2.image}
//                     className="rounded-full w-28 h-28 place-items-center"
//                   ></img>
//                   <p className="text-md text-base md:pt-4 text-center">
//                     Tote Bag
//                   </p>
//                 </a>
//               </a>
//             </div>
//             <div className="pb-10 place-items-center">
//               <a href="https://theasteria.shop/">
//                 <a href="https://theasteria.shop/">
//                   <img
//                     src={imageCodes.collection1.image}
//                     className="rounded-full w-28 h-28 place-items-center"
//                   ></img>
//                   <p className="text-md text-base md:pt-4 text-center">
//                     Merch Tee
//                   </p>
//                 </a>
//               </a>
//             </div>
//             <div className="pb-10 place-items-center">
//               <a href="https://theasteria.shop/">
//                 <a href="https://theasteria.shop/">
//                   <img
//                     src={imageCodes.collection2.image}
//                     className="rounded-full w-28 h-28 place-items-center"
//                   ></img>
//                   <p className="text-md text-base md:pt-4 text-center">
//                     Casual Wear
//                   </p>
//                 </a>
//               </a>
//             </div>
//           </div>
//         </div>
//         {/*                    end of Categories Section                   */}

//         {/*                        hero product section                        */}
//         <div>
//           <h1 className="text-xl lg:text-3xl xl:text-3xl font-semibold pb-10 text-center">
//             {titleCodes.newArrival.title}
//           </h1>
//           <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 pb-20 lg:px-20 xl:px-20 px-4">
//             <div className="md:px-10 lg:pr-2 xl:pr-2">
//               <img
//                 src={imageCodes.newItem.image}
//                 className="hover:-translate-y-1 duration-300 ..."
//               ></img>
//               <a href="https://theasteria.shop/product/cl5gk6z5573142501s6eapzw7zb">
//                 <p className="py-4 hover:animate-bounce pb-10">
//                   {textCodes.dateSet.text}
//                 </p>
//               </a>
//             </div>
//             <div className="md:px-10 lg:pl-2 xl:pl-2">
//               <img
//                 src={imageCodes.heroProduct2.image}
//                 className="hover:-translate-y-1 duration-300 ..."
//               ></img>
//               <a href="https://theasteria.shop/product/XCR65t3pPKq04JpyyxYG">
//                 <p className="py-4 hover:animate-bounce">
//                   {textCodes.fitBlazer.text}
//                 </p>
//               </a>
//             </div>
//           </div>
//         </div>
//         {/*                        end of hero product section                        */}

//         {/*            choose reason asteria section                  */}
//         <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 lg:grid-gap-16 md:gap-8 px-4">
//           <div className="md:px-10">
//             <img
//               src={imageCodes.chooseUs.image}
//               className="hover:-translate-y-4 duration-300 ..."
//             ></img>
//           </div>
//           <div className="w-fix md:px-10">
//             <h1 className="text-xl lg:text-2xl xl:text-3xl font-semibold md:pr-0 pt-10 lg:pt-0 xl:pt-10">
//               {titleCodes.reasonTitle.title}
//             </h1>
//             <div>
//               <ul className="list-none py-14 lg:py-4 xl:py-14">
//                 <li className="px-2 pb-8">
//                   <div className="flex">
//                     <img
//                       src={imageCodes.hanger.image}
//                       width={30}
//                       height={10}
//                     ></img>
//                     <h1 className="text-xl text-bold pl-4 md:pl-4">
//                       {titleCodes.reasonTitle1.title}
//                     </h1>
//                   </div>
//                   <p className="text-grey pr-4 pt-4 md:p-0">
//                     {textCodes.reason1.text}
//                   </p>
//                 </li>
//                 <li className="px-2 pb-8">
//                   <div className="flex">
//                     <img
//                       src={imageCodes.hanger.image}
//                       width={30}
//                       height={10}
//                     ></img>
//                     <h1 className="text-xl text-bold pl-4 md:pl-4">
//                       {titleCodes.reasonTitle2.title}
//                     </h1>
//                   </div>
//                   <p className="text-grey pr-4 pt-4 md:p-0">
//                     {textCodes.reason2.text}
//                   </p>
//                 </li>
//                 <li className="px-2">
//                   <div className="flex">
//                     <img
//                       src={imageCodes.hanger.image}
//                       width={30}
//                       height={10}
//                     ></img>
//                     <h1 className="text-xl text-bold pl-4 md:pl-4">
//                       {titleCodes.reasonTitle3.title}
//                     </h1>
//                   </div>
//                   <p className="text-grey pr-4 pt-4">
//                     {textCodes.reason3.text}
//                   </p>
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </div>
//         {/*           end of choose reason asteria            */}

//         {/*                  feature products section                */}
//         <div className="w-fix">
//           <div className="pt-10 lg:pt-20 xl:pt-20">
//             <h1 className="text-xl lg:text-3xl xl:text-3xl font-semibold pb-10 text-center">
//               {titleCodes.featureTitle.title}
//             </h1>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 pb-14 place-items-center gap-0">
//             <div className="px-4 pb-8">
//               <div class="card w-80 md:w-72 md:mb-8 shadow-xl hover:animate-pulse">
//                 <a href="https://theasteria.shop/product/ACzYJkGFftjX8cLJnUKB">
//                   <figure>
//                     <img src={imageCodes.collection1.image} alt="Date Set" />
//                   </figure>
//                 </a>
//                 <div class="card-body">
//                   <h2 class="card-title">Champagne Date Set!</h2>
//                   <div class="card-actions justify-end">
//                     <div class="badge badge-outline">Fashion</div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="px-4 pb-10">
//               <div class="card w-80 md:w-72 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
//                 <a href="https://theasteria.shop/product/XCR65t3pPKq04JpyyxYG">
//                   <figure>
//                     <img src={imageCodes.collection2.image} alt="blazer" />
//                   </figure>
//                 </a>
//                 <div class="card-body">
//                   <h2 class="card-title">Timeless Fitted Blazer!</h2>
//                   <div class="card-actions justify-end">
//                     <div class="badge badge-outline">Fashion</div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="px-4 pb-10">
//               <div class="card w-80 md:w-72 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
//                 <a href="https://theasteria.shop/product/dSdyW9TkPoQFiQbWA0cR">
//                   <figure>
//                     <img src={imageCodes.collection1.image} alt="Tee" />
//                   </figure>
//                 </a>
//                 <div class="card-body">
//                   <h2 class="card-title">Embroidery Tee!</h2>
//                   <div class="card-actions justify-end">
//                     <div class="badge badge-outline">Fashion</div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="px-4 pb-10">
//               <div class="card w-80 md:w-72 md:mb-8 bg-base-100 shadow-xl hover:animate-pulse">
//                 <a href="https://theasteria.shop/product/UXtc9c94t6eEuFbf2cXs">
//                   <figure>
//                     <img src={imageCodes.collection2.image} alt="Tote Bag" />
//                   </figure>
//                 </a>
//                 <div class="card-body">
//                   <h2 class="card-title">Embroidery Tote Bag!</h2>
//                   <div class="card-actions justify-end">
//                     <div class="badge badge-outline">Fashion</div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/*                  end of feature products section                */}

//         {/*          shop now and youtube video section             */}
//         <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-20 pb-10 lg:pb-14 bg-[#ffffff]">
//           <div className="mx-10 md:px-10">
//             <h1 className="text-xl lg:text-3xl xl:text-3xl lg:pt-0 xl:pt-60">
//               {textCodes.having.text}
//             </h1>
//             <div className="pt-10 lg:pt-8">
//               <a
//                 class="btn btn-outline text-xl lowercasegit lowercase"
//                 href="https://theasteria.shop/"
//               >
//                 {textCodes.shopNow.text}
//               </a>
//             </div>
//           </div>
//           <div className="md:px-10">
//             <iframe
//               src={videoCodes.video2.video}
//               title="YouTube video player"
//               frameborder="0"
//               allow="accelerometer; autoplay; clipboard-write;
//                             encrypted-media; gyroscope; picture-in-picture"
//               allowfullscreen
//               className="w-full h-60 lg:w-5/6 lg:h-full xl:w-5/6 xl:h-screen px-4 xl:py-10 xl:pb-20"
//             ></iframe>
//           </div>
//         </div>
//         {/*          end of shop now and youtube video section             */}

//         {/*                    founder's code                    */}
//         <div className="container grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 px-4">
//           <div>
//             <img
//               src={imageCodes.founderCodes.image}
//               className="w-fix md:w-full"
//             ></img>
//           </div>
//           <div className="bg-bggrey pt-10 md:pt-12 px-2 text-center">
//             <h1 className="text-lg pt-2 leading-7 lg:text-xl xl:text-xl">
//               {textCodes.sologan1.text}
//             </h1>
//             <p className="text-right pt-10 font-semibold">
//               {titleCodes.founder1.title}
//             </p>
//           </div>
//         </div>
//         {/*                    end of founder's code                    */}

//         {/*                collaboration brand                      */}
//         <div className="items-center text-center w-full bg-[#ffffff] pt-10">
//           <h1 className="text-xl lg:text-3xl xl:text-3xl font-semibold">
//             {titleCodes.collaboration.title}
//           </h1>
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-0">
//             <div className="text-center pt-10 md:pt-20 lg:pt-20 xl:pt-20 lg:pl-40 xl:pl-40">
//               <img
//                 src="https://tmpl-set.web.app/static/media/asteria_logo.b6eb47d1f26e3cd194f9.png"
//                 alt=""
//                 className="w-42  mx-auto"
//               />
//             </div>
//             <div className="grid grid-cols-3 text-center">
//               <div class="avatar p-10 text-center">
//                 <div class="w-32 rounded hover:animate-bounce text-center">
//                   <img src={imageCodes.herCo.image} className="text-center" />
//                 </div>
//               </div>
//               <div class="avatar p-10 text-center">
//                 <div class="w-32 rounded hover:animate-bounce text-center p-2 md:p-1 lg:p-6">
//                   <img src={imageCodes.spex.image} className="text-center rounded-lg shadow-lg" />
//                 </div>
//               </div>

//               <div class="avatar p-10 md:p-4 md:pl-4 text-center">
//                 <div class="w-32 rounded hover:animate-bounce md:text-center">
//                   <img
//                     src={imageCodes.littleOdd.image}
//                     className="md:text-center"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/*              end of collaboration brand                      */}
//       </div>
//     </React.Fragment>
//   );
// }

// export default Home;

import {
  BackgroundImage,
  Box,
  Center,
  Divider,
  Flex,
  Image,
  Text,
} from "@mantine/core";
import React from "react";
import logo from "../../assets/images/asteria/asteria_logo.png";
import { motion } from "framer-motion";
import ProductCarousel from "../../components/asteria/product_carousel";
import CardSlide from "../../components/asteria/Slider/card_slide";
import DesignerChoice from "../../components/asteria/designer_choice";
import HomeVideo from "../../components/asteria/home_video";
import Reasons from "../../components/asteria/reasons";

const Home = () => {
  return (
    <Box>
      <Image
        src={
          "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fbanner1.png?alt=media&token=da76a63f-bb41-49e3-bc48-bf507bf87c51"
        }
      />
      <Flex
        className="justify-center items-center my-20 gap-20 w-[80%] mx-auto"
        wrap={"wrap-reverse"}
      >
        <img
          src={
            "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio8.jpg?alt=media&token=bc6485b0-2962-437d-b9cf-6dec7345309f"
          }
          className="w-52 h-80 object-cover object-center rounded shadow-sm"
        />
        <img
          src={
            "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio9.jpg?alt=media&token=f0fc9940-3665-4cc1-9c43-7a9af185812e"
          }
          className="w-52 h-80 md:w-96 md:h-[600px] object-cover object-center rounded shadow-sm"
        />
        <Box w={"200px"}>
          <Text className="text-2xl text-[#D8AE96] font-bold">
            2023 Asteria
          </Text>
          <Text className="text-xl text-[#D8AE96] font-bold">Collection</Text>
          <Divider className="my-3" />
          <Text className="text-sm text-gray-500 italic">
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur
            iste adipisci, minima neque ducimus assumenda odit inventore.
          </Text>
        </Box>
      </Flex>

      <Flex className="items-center justify-center gap-10" wrap={"wrap"}>
        <Text className="text-xl text-[#D8AE96]">The Asteria Collection</Text>
        <img
          src={
            "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fasteria%2Fitems%2F1679316723501c1fd90ac04db01c6626b90d0bfb80dd8?alt=media&token=3792b5cf-84cd-46e9-93b9-e87d11c87832"
          }
          className="w-52 h-80 object-cover object-center rounded shadow-sm"
        />
        <img
          src={
            "https://firebasestorage.googleapis.com/v0/b/df-kirin.appspot.com/o/pos%2F1638330127465e9177d838159976c2bddb4f1095279f9?alt=media&token=e69f784c-b034-43e9-a923-102c505e4424"
          }
          className="w-52 h-80 object-cover object-center rounded shadow-sm"
        />
        <img
          src={
            "https://firebasestorage.googleapis.com/v0/b/df-kirin.appspot.com/o/pos%2F16440396844088c22c3b03c51bebfef5e05ffc749fe07?alt=media&token=fd57996d-af75-4c85-bfb1-fecc38b298b4"
          }
          className="w-52 h-80 object-cover object-center rounded shadow-sm"
        />
      </Flex>
      <Box className="m-10">
        <DesignerChoice />
      </Box>
      <Box className="m-10">
        {/* <Text align="center" className="text-2xl font-bold text-[#D8AE96] mb-5">Latest Products</Text> */}
        {/* <ProductCarousel /> */}
        <CardSlide />
      </Box>
      <Box className="m-10">
        <HomeVideo />
      </Box>
      <Box className="m-10">
        <Reasons />
      </Box>
    </Box>
  );
};

export default Home;
